import React from 'react';

function RecurrenceModPopup({ handleClose, data, flag, callback }) {
  const selectAction = (val) => {
    callback(val);
    handleClose();
  };
  return (
    <div className="modalBackground">
      <div className="treatment-plan-container">
        <div className="treatment-plan-head">
          <span>
            {`${data?.patient_name}`} {'  '}
            {`[${data?.chart}]`} {`- ${data?.patage}`} {'  '}
            {`- ${data?.gender}`}
            {'  '}
            {flag === 'del' ? '(Delete)' : ''}
            {flag === 'can' ? '(Cancel)' : ''}
            {flag === 'change' ? '(Change)' : ''}
          </span>
          <span className="treatment-plan-close" onClick={handleClose}>
            X
          </span>
        </div>
        <div className="treatment-plan-body med-common-bg">
          <div className="treatment-plan-check">
            <b>Future appointments left in the series: {data?.occurenceLeft}</b>
          </div>
          <div className="treatment-plan-check">
            <input
              type="radio"
              name="selectAction"
              onClick={() => selectAction('0')}
              style={{ marginRight: '10px' }}
            />
            This instance
          </div>
          <div className="treatment-plan-check">
            <input
              type="radio"
              name="selectAction"
              onClick={() => selectAction('1')}
              style={{ marginRight: '10px' }}
            />
            This &amp; all the future instances
          </div>
        </div>
        <div className="treatment-plan-foot">
          <span className="right button-submit" onClick={handleClose}>
            Close
            <p />
          </span>
        </div>
      </div>
    </div>
  );
}

export default RecurrenceModPopup;
